import * as React from 'react';
import ReactDOM from 'react-dom';
import Text from './shared/Text';
import { App } from './js/components/app';

Text.initialize({}).then(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
